// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Igyc6","col":"styles_col__1DxX7","actions":"styles_actions__1vhGw","conflict":"styles_conflict__3SQ4N"};